import * as React from "react";
const SvgFiRrBoxOpenFull = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-box-open-full_svg__a)">
      <path
        fill="#062147"
        d="m23.61 10.836-1.718-3.592a1 1 0 0 0-1.22-.517l-8.676 2.896-8.69-2.895a1 1 0 0 0-1.218.518L.436 10.72a3.01 3.01 0 0 0-.247 2.61c.31.84.964 1.49 1.8 1.794l-.005 2.315a5 5 0 0 0 3.419 4.747l4.365 1.456a7.04 7.04 0 0 0 4.428 0l4.369-1.457a4.99 4.99 0 0 0 3.419-4.738l.006-2.322a2.98 2.98 0 0 0 1.819-1.788c.316-.858.227-1.8-.2-2.5m-21.416.83 1.318-2.763 7.065 2.354-1.62 3.256a1 1 0 0 1-1.174.436l-5.081-1.695a1.02 1.02 0 0 1-.64-.618c-.107-.293-.076-.616.132-.97m3.842 8.623a3 3 0 0 1-2.052-2.848l.004-1.65 3.164 1.055c1.346.446 2.793-.09 3.559-1.372l.277-.555-.004 6.98a5 5 0 0 1-.582-.155zm11.896-.002-4.37 1.456q-.285.095-.58.155l.005-6.995.319.64a2.98 2.98 0 0 0 3.522 1.303l3.16-1.053-.004 1.651a2.99 2.99 0 0 1-2.052 2.843m4-7.645a1 1 0 0 1-.62.601l-5.117 1.705c-.438.147-.935-.036-1.136-.365l-1.654-3.322 7.064-2.357 1.382 2.88a.99.99 0 0 1 .08.858M5.214 5.896a1 1 0 0 1 0-1.414L9.11.586a2.003 2.003 0 0 1 2.828 0l1.596 1.596c.753-.385 1.738-.27 2.353.345l2.255 2.255a.999.999 0 1 1-1.414 1.414l-2.255-2.255-3.151 3.151a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.147-2.147-1.53-1.53-3.897 3.896a.997.997 0 0 1-1.414 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-box-open-full_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoxOpenFull;
